import { render, staticRenderFns } from "./ArticleCategorySetting.vue?vue&type=template&id=582d87ea"
import script from "./ArticleCategorySetting.vue?vue&type=script&lang=js"
export * from "./ArticleCategorySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports